<template>
  <layout-main-inner
    showBack
    :title="$route.meta.name+ `(${config.vendorName}-${config.certName})`">
    <div
      v-if="permission.LVL2"
      slot="action">
      <el-button
        type="primary"
        @click="additem">新增证书文件</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-button
          type="primary"
          @click="getlist">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="证书图片"
          min-width="360px">
          <template slot-scope="{row}">
            <image-list :list="row.certFile" />
          </template>
        </el-table-column>
        <el-table-column
          label="有效期"
          min-width="180">
          <template slot-scope="{row}">
            {{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          fixed="right"
          label="操作"
          width="135">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)"> 编辑证书文件 </el-button>
            <el-button
              type="text"
              @click="deleteitem(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </layout-card-wrap>

    <certificate-modal
      ref="modal"
      @fetch="getlist" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import ImageList from '../../../components/image-list.vue'
import CertificateModal from './certificate-modal.vue'
export default {
  name: 'CertificateFile',
  components: { CertificateModal, ImageList },
  data() {
    return {
      loading: true,
      list: [],
      config: { vendorName: '', vendorId: null, certName: '', certId: null }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.config = { ...this.config, ...this.$route.query }
    this.getlist()
  },
  methods: {
    additem() {
      const { certId, certName } = this.config
      this.$refs.modal.init({ certId, certName })
    },
    updateitem(row) {
      const { certId, certName } = this.config
      const { certFileId, certFile, certBeginTime, certEndTime } = row
      const time = [new Date(certBeginTime), new Date(certEndTime)]
      this.$refs.modal.init({ certId, certName, certFileId, certFile, time })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该证书文件?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.deletecertificatefile({ certFileId: row.certFileId, vendorId: this.config.vendorId, certId: row.certId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.$message.success('删除成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    getlist() {
      this.loading = true
      this.$$examApi.getcertificate(this.config)
        .then(res => {
          this.loading = false
          const { result, message, certFiles } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.list = certFiles.map(i => ({ ...i, certFile: this.$splitImage(i.certFile) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
